import React from 'react'
import './style/Unternehmeswerte.css'

import etnisch from '../resources/unternehmenswerte/etnisch.png'

import quality from '../resources/unternehmenswerte/quality.png'
import gesund from '../resources/unternehmenswerte/gesund.png'
import bio from '../resources/unternehmenswerte/bio.png'

const Unternehmeswerte = () => {
  return (
    <div className='unternehmenswerteDiv'>
      <div className='unternehmenswert'>
        <p>Gesund - helle Röstung</p>
        <img src={gesund} />
      </div>
      <div className='unternehmenswert'>
        <p>Ethisch produziert</p>
        <img src={etnisch} />
      </div>{' '}
      <div className='unternehmenswert'>
        <p>Bio Zertifiziert</p>
        <img src={bio} />
      </div>{' '}
      <div className='unternehmenswert'>
        <p>Hohe Qualität</p>
        <img src={quality} />
      </div>
    </div>
  )
}

export default Unternehmeswerte
